module.exports = __webpack_public_path__ + "img/icon_communication.691cb48.svg";